import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Corporatecabserviceinhitechcityhyderabad() {



  const cardData =
  {
    keyword: ' Corporate Cab Service in Hitech City Hyderabad',
    heading: 'Pune Corporate Cars India Private Limited: Corporate Cab Service in Hitech City Hyderabad',
    headingDescription: 'Pune Corporate Cars India Private Limited provides professional and reliable Corporate Cab Service in Hitech City Hyderabad, catering to the transportation needs of IT companies, corporate offices, and business centers in the area. Our fleet of executive sedans, SUVs, and premium vehicles ensures safe, comfortable, and punctual travel for employees, clients, and senior executives. Whether it is daily office commute, airport transfers, inter-office travel, business meetings, or VIP transportation, we deliver seamless and hassle-free mobility solutions. With trained chauffeurs, flexible rental plans, and well-maintained vehicles, Pune Corporate Cars India Private Limited ensures a premium and dependable corporate travel experience for businesses operating in and around Hitech City Hyderabad.',

    top: 'Top Places to Visit in Hyderabad with Pune Corporate Car',

"topPlaces": [
  {
    "title": "Charminar",
    "description": "Charminar is Hyderabad’s most iconic landmark, built in 1591 by Sultan Muhammad Quli Qutb Shah. This grand square-shaped monument features four towering minarets and intricate Islamic architecture. Surrounded by bustling bazaars, street food vendors, and shops selling pearls, bangles, and traditional crafts, Charminar is a cultural and historical hub, attracting tourists from across India and the world."
  },
  {
    "title": "Golconda Fort",
    "description": "Golconda Fort is a majestic fortress located on the outskirts of Hyderabad, known for its massive walls, impressive gateways, and acoustic marvels. Once the capital of the Qutb Shahi dynasty, it offers panoramic views of the city and nearby hills. The evening light and sound show narrates the fort’s rich history, making it a favorite destination for history enthusiasts and photographers."
  },
  {
    "title": "Hussain Sagar Lake",
    "description": "Hussain Sagar Lake is a large man-made lake in the heart of Hyderabad, famous for the gigantic Buddha statue standing on Gibraltar Rock in the middle of the water. The lake is popular for boating, evening walks, and lakeside leisure. Surrounded by parks, eateries, and promenades, it serves as a serene escape and recreational spot for locals and tourists."
  },
  {
    "title": "Salar Jung Museum",
    "description": "Salar Jung Museum is one of India’s largest museums, housing an extensive collection of art, sculptures, manuscripts, and artifacts from India and around the world. Visitors can explore centuries of history and culture through exhibits such as Mughal miniatures, European paintings, and decorative arts. The museum provides an immersive educational experience for art and history enthusiasts."
  },
  {
    "title": "Ramoji Film City",
    "description": "Ramoji Film City is one of the world’s largest film studio complexes and a popular entertainment destination near Hyderabad. Spread across thousands of acres, it features film sets, amusement rides, gardens, and live shows. Visitors can enjoy guided tours, interactive experiences, and cultural performances, making it a top choice for family outings and film enthusiasts."
  },
  {
    "title": "Chowmahalla Palace",
    "description": "Chowmahalla Palace is a stunning 18th-century palace that once served as the seat of the Nizams of Hyderabad. The complex features grand halls, intricate interiors, beautiful courtyards, and royal artifacts. Visitors can explore the opulent architecture and learn about the history and lifestyle of the Nizams, making it a cultural and historical gem of the city."
  },
  {
    "title": "Birla Mandir",
    "description": "Birla Mandir is a magnificent white marble temple dedicated to Lord Venkateswara, located on a hill overlooking Hyderabad. The temple offers panoramic views of the city and the lake below. Visitors can admire the detailed carvings, serene surroundings, and participate in spiritual rituals, making it a peaceful retreat in the heart of the city."
  },
  {
    "title": "Laad Bazaar",
    "description": "Laad Bazaar, located near Charminar, is Hyderabad’s famous shopping street, known for its vibrant bangles, jewelry, pearls, textiles, and handicrafts. The bustling markets and colorful storefronts create an authentic local experience. It is a must-visit for tourists looking to shop, explore, and enjoy the vibrant culture of the old city."
  },
  {
    "title": "Necklace Road",
    "description": "Necklace Road is a scenic boulevard along Hussain Sagar Lake, popular for evening walks, recreational activities, and lakeside dining. It features landscaped gardens, jogging tracks, and food stalls. The area is ideal for leisure, family outings, and enjoying the illuminated view of the Buddha statue on the lake."
  },
  {
    "title": "Qutb Shahi Tombs",
    "description": "The Qutb Shahi Tombs are the royal necropolis of the Qutb Shahi dynasty, located near Golconda Fort. The complex features grand domed tombs, landscaped gardens, and intricate stonework. Visitors can explore the historical architecture, learn about the dynasty’s legacy, and enjoy peaceful walks amidst the ancient structures."
  }
],


"services": [
{
"name": "Hitech City IT Cab",
"description": "Hitech City IT Cab provides a dedicated, tech-enabled mobility service designed for employees, executives, and visitors commuting to and from Hyderabad’s Hitech City. With a managed fleet of sedans, SUVs, shuttles, and premium vehicles, the service ensures punctual pickups, optimized routing, multi-shift support, and real-time GPS monitoring. It is built specifically for high-density IT corridors, delivering safe, reliable, and seamless daily travel backed by trained chauffeurs and end-to-end coordination."
},
{
"name": "Corporate Shuttle Hitech City",
"description": "Corporate Shuttle Hitech City offers large-capacity shuttle transport for companies located in the Hitech City business ecosystem. Featuring AC minibuses, automated attendance systems, zone-wise routing, multi-shift scheduling, and real-time vehicle tracking, the service ensures smooth, structured, and efficient mass employee movement. It is ideal for IT parks, tech campuses, and corporates managing large workforce mobility."
},
{
"name": "Staff Commute Hitech City",
"description": "Staff Commute Hitech City delivers organized employee transportation with planned pick-up/drop routes, GPS-enabled supervision, professional chauffeurs, and shift-aligned scheduling. Designed for companies requiring dependable everyday mobility, it ensures employees reach their offices safely, comfortably, and on time, regardless of peak-hour or late-night travel requirements."
},
{
"name": "Office Cab Hitech City",
"description": "Office Cab Hitech City offers structured office pickup and drop services with real-time ride tracking, punctual scheduling, and rigid safety protocols. Suitable for tech companies, BPOs, corporate offices, and business centres in Hitech City, the service maintains consistent travel reliability with clean vehicles and verified drivers across all routes."
},
{
"name": "Employee Pickup Drop Hitech City",
"description": "Employee Pickup Drop Hitech City provides well-planned, fixed-route commuting solutions tailored for diverse workforce requirements. With route optimization, live tracking, trained chauffeurs, and digital attendance integration, it ensures smooth, timely, and secure employee travel for all shifts within the Hitech City region."
},
{
"name": "Business Cab Hitech City",
"description": "Business Cab Hitech City offers premium corporate travel solutions including client visits, executive mobility, airport transfers, and inter-office trips. The fleet features modern sedans and SUVs operated by trained chauffeurs who follow corporate etiquette. The service ensures on-demand availability, punctuality, and comfort for business professionals."
},
{
"name": "Monthly Cab Hitech City",
"description": "Monthly Cab Hitech City provides subscription-based corporate transportation with dedicated vehicles, assigned drivers, maintenance coverage, and centralized scheduling. Designed for companies needing uninterrupted month-long commute support, it guarantees predictable costs, reliable availability, and smooth day-to-day mobility for employees and executives."
},
{
"name": "Best Corporate Cab Hitech City",
"description": "Best Corporate Cab Hitech City offers top-tier mobility with well-maintained vehicles, experienced chauffeurs, premium comfort, and strong safety compliance. Ideal for senior management, VIP clients, and executives, it ensures a polished and professional travel experience across Hyderabad’s major business hubs."
},
{
"name": "Affordable Cab Hitech City",
"description": "Affordable Cab Hitech City delivers cost-effective yet high-quality transportation designed for startups, SMEs, and mid-sized organizations. Featuring clean vehicles, efficient routing, trained drivers, and transparent pricing, it enables companies to manage daily commuting without compromising on reliability, safety, or comfort."
},
{
"name": "Outstation Cab Hitech City",
"description": "Outstation Cab Hitech City offers comfortable long-distance travel for corporate meetings, factory visits, intercity client interactions, and executive road trips. With experienced drivers, modern vehicles, interstate permits, and GPS tracking, the service ensures safe, smooth, and professionally managed outstation movement for corporate needs."
},
{
"name": "Sedan Cab Hitech City",
"description": "Sedan Cab Hitech City provides executive sedans ideal for airport transfers, managerial commute, business meetings, and premium corporate travel. The service ensures comfort, safety, punctuality, and a refined travel experience supported by well-trained drivers and high-quality vehicle standards."
},
{
"name": "SUV Cab Hitech City",
"description": "SUV Cab Hitech City delivers spacious, premium SUVs suitable for senior executives, group travel, long-distance trips, and high-comfort commuting. The service emphasizes security, comfort, and reliability with skilled chauffeurs, GPS monitoring, and well-maintained vehicles built for corporate mobility."
},
{
"name": "Company Fleet Hitech City",
"description": "Company Fleet Hitech City offers full-scale fleet outsourcing solutions including sedans, SUVs, staff cabs, shuttle vans, and premium vehicles. It includes driver management, vehicle maintenance, GPS monitoring, compliance oversight, and centralized fleet planning to support companies with complete mobility management."
},
{
"name": "IT Park Transport Hitech City",
"description": "IT Park Transport Hitech City provides specialized commute services for IT professionals working in Hitech City’s major tech hubs. It features optimized multi-shift routing, real-time ride tracking, automated scheduling, and safety-driven operations tailored to the dynamic requirements of large IT workforces."
},
{
"name": "Corporate Mobility Hitech City",
"description": "Corporate Mobility Hitech City delivers comprehensive mobility solutions that include employee transport, executive travel, visitor movement, shuttle operations, and dedicated fleet management. With strong operational controls, modern vehicles, trained chauffeurs, and safety protocols, it supports organizations in running reliable and scalable mobility operations across Hitech City."
}
],

"tableData": [
["Hitech City IT Cab", "Corporate Shuttle Hitech City"],
["Staff Commute Hitech City", "Office Cab Hitech City"],
["Employee Pickup Drop Hitech City", "Business Cab Hitech City"],
["Monthly Cab Hitech City", "Best Corporate Cab Hitech City"],
["Affordable Cab Hitech City", "Outstation Cab Hitech City"],
["Sedan Cab Hitech City", "SUV Cab Hitech City"],
["Company Fleet Hitech City", "IT Park Transport Hitech City"],
["Corporate Mobility Hitech City", ""]
],


  





"whychoose": [
  {
    "WhyChooseheading": "Corporate Cab Service in Hitech City Hyderabad",
    "WhyChoosedescription": "Pune Corporate Cars India Private Limited provides dependable corporate cab services in Hitech City Hyderabad, ensuring efficient and comfortable transportation for employees and business executives."
  },
  {
    "WhyChooseheading": "Timely Pickups & Drop-offs",
    "WhyChoosedescription": "We offer punctual pickups and drop-offs across Hitech City, Cyberabad, IT parks, and nearby business hubs, ensuring employees reach workplaces and meetings on time."
  },
  {
    "WhyChooseheading": "Professional & Experienced Drivers",
    "WhyChoosedescription": "Our expert chauffeurs deliver safe, polite, and disciplined travel, ensuring a secure and comfortable journey for corporate passengers."
  },
  {
    "WhyChooseheading": "Well-Maintained Vehicle Fleet",
    "WhyChoosedescription": "Our fleet includes sedans, SUVs, tempo travellers, and buses—each regularly cleaned, sanitized, and serviced to maintain high standards of corporate travel."
  },
  {
    "WhyChooseheading": "Customized Corporate Travel Packages",
    "WhyChoosedescription": "We provide flexible and tailored transportation plans designed to meet the commuting needs of companies and employees in Hitech City Hyderabad."
  },
  {
    "WhyChooseheading": "24/7 Corporate Travel Support",
    "WhyChoosedescription": "Our support team is available 24/7 to handle bookings, sudden travel needs, and route changes, ensuring uninterrupted corporate mobility."
  },
  {
    "WhyChooseheading": "Safe & Hygienic Rides",
    "WhyChoosedescription": "All vehicles are sanitized regularly and equipped with essential safety features, ensuring secure and hygienic rides for employees and executives."
  },
  {
    "WhyChooseheading": "Efficient Booking & Coordination",
    "WhyChoosedescription": "Our streamlined booking system and reliable coordination make corporate travel management simple and hassle-free for HR and admin teams."
  }
]







































  }

  
const faqData = [
  {
    question: 'Do you provide corporate cab services in Hitech City, Hyderabad?',
    answer: 'Yes, Pune Corporate Cars India Private Limited offers dedicated and reliable corporate cab services for companies and IT parks in Hitech City, Hyderabad.',
  },
  {
    question: 'What types of corporate cab services do you offer in Hitech City?',
    answer: 'We provide employee transportation, corporate pickups and drops, last-mile shuttle services, airport transfers, and end-to-end fleet management.',
  },
  {
    question: 'Do you support daily employee commute services in Hitech City?',
    answer: 'Yes, we offer well-organized daily commute services with optimized routing, punctual pickups, and multi-shift transportation options.',
  },
  {
    question: 'How can companies book corporate cab services in Hitech City?',
    answer: 'Bookings can be made through our website, mobile app, or by contacting our 24×7 corporate support team.',
  },
  {
    question: 'What vehicle options are available for companies in Hitech City?',
    answer: 'We offer sedans, hatchbacks, SUVs, Innova Crysta, luxury cars, tempo travellers, and electric cabs depending on company needs.',
  },
  {
    question: 'Do you offer long-term corporate cab contracts for Hitech City businesses?',
    answer: 'Yes, we provide monthly, quarterly, and annual cab contracts with flexible pricing and complete fleet management.',
  },
  {
    question: 'Are your vehicles equipped with GPS and safety features?',
    answer: 'Yes, all our vehicles are GPS-enabled, sanitized regularly, and driven by trained and background-verified chauffeurs.',
  },
  {
    question: 'Do you support night shift and 24×7 operations in Hitech City?',
    answer: 'Absolutely. We offer transportation solutions for night shifts, rotational shifts, early morning pickups, and weekend operations.',
  },
  {
    question: 'What payment modes are accepted for corporate cab services?',
    answer: 'We accept UPI, digital wallets, bank transfers, credit/debit cards, and also provide consolidated corporate invoicing.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rohit Kasireddy',
    feedback: 'Top-notch corporate cab service for our Hitech City office. Very reliable drivers and excellent coordination every day.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Swathi Garlapati',
    feedback: 'Their employee commute service is consistent and highly professional. Our team appreciates their punctuality and clean vehicles.',
    rating: 5,
  },
];








































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Corporate Cab Services in Pune", link: "corporate-cab-services-in-pune" },
{ place: "/images/keyword/2.jpg", text: "Monthly Cab Services in Pune", link: "monthly-cab-services-in-pune" },
{ place: "/images/keyword/3.jpg", text: "Corporate Car Rental in Pune", link: "corporate-car-rental-in-pune" },
{ place: "/images/keyword/4.jpg", text: "Corporate Car Rentals Services in Pune", link: "corporate-car-rentals-services-in-pune" },
{ place: "/images/keyword/5.jpg", text: "Corporate cab services for Pune Outstation", link: "corporate-cab-services-for-pune-outstation" },
{ place: "/images/keyword/6.jpg", text: "Corporate Cab Service in Kharadi", link: "corporate-cab-service-in-kharadi" },
{ place: "/images/keyword/7.jpg", text: "Corporate Cab Service in Hadapsar", link: "corporate-cab-service-in-hadapsar" },
{ place: "/images/keyword/8.jpg", text: "Corporate Cab Service in Viman Nagar", link: "corporate-cab-service-in-viman-nagar" },
{ place: "/images/keyword/9.jpg", text: "Monthly Pick and Drop Service Pune", link: "monthly-pick-and-drop-service-pune" },
{ place: "/images/keyword/10.jpg", text: "Corporate Cab Services in Hinjewadi", link: "corporate-cab-services-in-hinjewadi" },
{ place: "/images/keyword/11.jpg", text: "Corporate Cab Service in Talegaon MIDC", link: "corporate-cab-service-in-talegaon-midc" },
{ place: "/images/keyword/12.jpg", text: "Corporate Cab Services in Chakan MIDC", link: "corporate-cab-services-in-chakan-midc" },
{ place: "/images/keyword/13.jpg", text: "Corporate Cab Services in Talawade MIDC", link: "corporate-cab-services-in-talawade-midc" },
{ place: "/images/keyword/14.jpg", text: "Cab Service for IT Company in Pune", link: "cab-service-for-it-company-in-pune" },
{ place: "/images/keyword/15.jpg", text: "Corporate Cab Services in Bhosari MIDC", link: "corporate-cab-services-in-bhosari-midc" },
{ place: "/images/keyword/16.jpg", text: "Office Pickup and Drop Service in Pune", link: "office-pickup-and-drop-service-in-pune" },
{ place: "/images/keyword/17.jpg", text: "Corporate Cabs Services in Sanaswadi", link: "corporate-cabs-services-in-sanaswadi" },
{ place: "/images/keyword/18.jpg", text: "Corporate Cab Services in Ranjangaon MIDC", link: "corporate-cab-services-in-ranjangaon-midc" },
{ place: "/images/keyword/19.jpg", text: "Corporate Cab Services in Karegaon MIDC", link: "corporate-cab-services-in-karegaon-midc" },
{ place: "/images/keyword/20.jpg", text: "Corporate Cab Services in Shirwal MIDC", link: "corporate-cab-services-in-shirwal-midc" },
{ place: "/images/keyword/21.jpg", text: "Corporate Cab Services in Shikrapur MIDC", link: "corporate-cab-services-in-shikrapur-midc" },
{ place: "/images/keyword/22.jpg", text: "Cab Service in Jejuri MIDC", link: "cab-service-in-jejuri-midc" },
{ place: "/images/keyword/23.jpg", text: "Best Cab Service for Corporate Employees Pune", link: "best-cab-service-for-corporate-employees-pune" },
{ place: "/images/keyword/24.jpg", text: "Corporate Travel Companies in Pune", link: "corporate-travel-companies-in-pune" },
{ place: "/images/keyword/25.jpg", text: "Innova Crysta Hire for Corporate Events in Pune", link: "innova-crysta-hire-for-corporate-events-in-pune" }
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Corporate Cab Service in Hitech City Hyderabad",
  "image": "https://www.punecorporatecars.com/assets/images/corporate-cab-hitech-city.jpg", // replace with real image URL
  "description":
    "Pune Corporate Cars India Private Limited provides premium corporate cab services in Hitech City Hyderabad, including IT park cabs, employee pickup & drop, corporate shuttles, staff commute, business cabs, monthly corporate transport, outstation cab services, and complete corporate fleet solutions for companies operating in Hitech City.",
  "brand": {
    "@type": "Brand",
    "name": "Pune Corporate Cars India Private Limited"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5800",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2400",
    "availability": "https://schema.org/InStock",
    "url": "https://www.punecorporatecars.com/corporate-cab-service-hitech-city-hyderabad"
  }
};







  return (
    <div>

<Helmet>
  <title>Corporate Cab Service in Hitech City Hyderabad | Employee & IT Park Transport</title>

  <meta
    name="description"
    content="Reliable corporate cab services in Hitech City Hyderabad including IT park cabs, employee pickup & drop, corporate shuttles, business taxis, monthly cab plans, outstation travel, and full fleet solutions."
  />

  <meta
    name="keywords"
    content="Hitech City IT Cab, Corporate Shuttle Hitech City, Staff Commute Hitech City, Office Cab Hitech City, Employee Pickup Drop Hitech City, Business Cab Hitech City, Monthly Cab Hitech City, Best Corporate Cab Hitech City, Affordable Cab Hitech City, Outstation Cab Hitech City, Sedan Cab Hitech City, SUV Cab Hitech City, Company Fleet Hitech City, IT Park Transport Hitech City, Corporate Mobility Hitech City"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <section
        className="breadcrumb-section"
        style={{ backgroundImage: "url(/images/background/inner-banner-bg.jpg)" }}
      >
        <div className="container">
          <div className="banner-content">
            <h1>{cardData.keyword}</h1>
          </div>
        </div>
      </section>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/77.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Pune Corporate Company</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Pune Corporate Company </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919822136667" className="pc-call">+91 9822136667</a>
                      <a href="tel:+917350959600" className="pc-call">+91 7350959600</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919822136667"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919822136667" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:sanjay.nalawade@punecorporatecars.com" className="pc-email">
                      sanjay.nalawade@punecorporatecars.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                     <strong>Pune Corporate Company</strong><br />
                      Gate No 124/2/1 Plot No 86 Vishva Vilas City
Lane No 08 Khandave Nagar Nagar Road Lohgaon
Haveli, Pune 412207 Maharashtra, India
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Corporatecabserviceinhitechcityhyderabad;